import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { FINALIZE_CHECKOUT_REQUEST, FINALIZE_CHECKOUT_SUCCESS, FINALIZE_CHECKOUT_ERROR } from '../types';
import { forgetCart, loadCart } from '../cart';
/**
 * Forget the finalized order and load a new cart
 *
 * Before forgetting, it checks that the order that we are trying
 * to forget is the same as the one in the state. This check is useful
 * for example when people refresh the order confirmation page after
 * adding other products to the new cart in other browser tabs.
 */
var forgetFinalizedCart = function forgetFinalizedCart(finalizedOrderNumber) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _cart$data;
      var _getState, cart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), cart = _getState.cart;
            if (!(((_cart$data = cart.data) === null || _cart$data === void 0 ? void 0 : _cart$data.number) === finalizedOrderNumber)) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return dispatch(forgetCart());
          case 4:
            dispatch(loadCart());
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var finalizeCheckoutRequest = function finalizeCheckoutRequest() {
  return {
    type: FINALIZE_CHECKOUT_REQUEST
  };
};
export var finalizeCheckoutSuccess = function finalizeCheckoutSuccess(_ref2) {
  var cart = _ref2.cart,
    products = _ref2.products,
    trackingIds = _ref2.trackingIds;
  return {
    type: FINALIZE_CHECKOUT_SUCCESS,
    cart: cart,
    products: products,
    trackingIds: trackingIds
  };
};
export var finalizeCheckoutError = function finalizeCheckoutError(error) {
  return {
    type: FINALIZE_CHECKOUT_ERROR,
    error: true,
    payload: error
  };
};
export var finalizeCheckout = function finalizeCheckout(options) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref3) {
      var chord, _getState2, cart, isStripe, finalizedOrder;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            chord = _ref3.chord;
            _getState2 = getState(), cart = _getState2.cart;
            isStripe = !!(options !== null && options !== void 0 && options.checkoutSessionId);
            dispatch(finalizeCheckoutRequest());
            _context2.prev = 4;
            dispatch(forgetFinalizedCart(options === null || options === void 0 ? void 0 : options.orderNumber));
            if (!isStripe) {
              _context2.next = 12;
              break;
            }
            _context2.next = 9;
            return chord.oms.finalizeCheckout({
              number: options === null || options === void 0 ? void 0 : options.orderNumber,
              token: null
            }, null, {
              checkoutSessionId: options.checkoutSessionId
            });
          case 9:
            _context2.t0 = _context2.sent;
            _context2.next = 15;
            break;
          case 12:
            _context2.next = 14;
            return chord.oms.finalizeCheckout({
              number: cart.data.number,
              token: cart.data.token
            });
          case 14:
            _context2.t0 = _context2.sent;
          case 15:
            finalizedOrder = _context2.t0;
            dispatch(finalizeCheckoutSuccess({
              cart: finalizedOrder,
              products: options === null || options === void 0 ? void 0 : options.products,
              trackingIds: options === null || options === void 0 ? void 0 : options.trackingIds
            }));
            return _context2.abrupt("return", finalizedOrder);
          case 20:
            _context2.prev = 20;
            _context2.t1 = _context2["catch"](4);
            dispatch(finalizeCheckoutError(_context2.t1));
            throw _context2.t1;
          case 24:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 20]]);
    }));
    return function (_x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};